"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const packFilterOptions = (clientOptions) => {
    const record = {};
    if (clientOptions !== undefined) {
        const { alertFrequency, directMessageType, threshold } = clientOptions;
        if (alertFrequency !== undefined) {
            record.alertFrequency = alertFrequency;
        }
        if (directMessageType !== undefined) {
            record.directMessageType = directMessageType;
        }
        if (threshold !== undefined) {
            record.threshold = threshold.toString();
        }
    }
    return JSON.stringify(record);
};
exports.default = packFilterOptions;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFja0ZpbHRlck9wdGlvbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvdXRpbHMvcGFja0ZpbHRlck9wdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxNQUFNLGlCQUFpQixHQUFHLENBQ3hCLGFBQWtELEVBQzFDLEVBQUU7SUFDVixNQUFNLE1BQU0sR0FBMkIsRUFBRSxDQUFDO0lBRTFDLElBQUksYUFBYSxLQUFLLFNBQVMsRUFBRTtRQUMvQixNQUFNLEVBQUUsY0FBYyxFQUFFLGlCQUFpQixFQUFFLFNBQVMsRUFBRSxHQUFHLGFBQWEsQ0FBQztRQUV2RSxJQUFJLGNBQWMsS0FBSyxTQUFTLEVBQUU7WUFDaEMsTUFBTSxDQUFDLGNBQWMsR0FBRyxjQUFjLENBQUM7U0FDeEM7UUFFRCxJQUFJLGlCQUFpQixLQUFLLFNBQVMsRUFBRTtZQUNuQyxNQUFNLENBQUMsaUJBQWlCLEdBQUcsaUJBQWlCLENBQUM7U0FDOUM7UUFFRCxJQUFJLFNBQVMsS0FBSyxTQUFTLEVBQUU7WUFDM0IsTUFBTSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUMsUUFBUSxFQUFFLENBQUM7U0FDekM7S0FDRjtJQUVELE9BQU8sSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQztBQUNoQyxDQUFDLENBQUM7QUFFRixrQkFBZSxpQkFBaUIsQ0FBQyJ9